import { PropsWithChildren } from 'react';
import styles from './FloatingComponent.module.scss';

export const FloatingComponent = ({ children }: PropsWithChildren) => {
  return <div className={styles.root}>
    {children}
  </div >
}